<div class="dc_footer">

  <ul>
      <li>
      
          <a  [ngClass]="{'active': isHActive(1)}"  href="javascript:void(0)" (click)="dashboardPage()" ><i class="icon-app_icon"></i></a>

      </li>
      
      <li>
      
          <a  [ngClass]="{'active': isHActive(2)}"  href="javascript:void(0)" (click)="planPage()"><i class="icon-menu_plan"></i></a>

      </li>
      
      <li>
      
          <a  [ngClass]="{'active': isHActive(3)}"  href="javascript:void(0)" (click)="searchPage()" class="active"><i class="icon-search_icon"></i></a>

      </li>
      
      <li>
      
          <a [ngClass]="{'active': isHActive(4)}" href="javascript:void(0)" (click)="reportPage()" ><i class="icon-menu_net"></i></a>

      </li>
      
      <li>
  
          <a  [ngClass]="{'active': isHActive(5)}" href="javascript:void(0)" (click)="settingPage()"><i class="icon-setting_icon"></i></a>

      </li>
  </ul>

</div>